import { cn } from '@/shared/lib/cn';

interface SkeletonProps {
  className?: string;
}

/** Placeholder de carregamento. Decorativo: fica fora da árvore de acessibilidade. */
export function Skeleton({ className }: SkeletonProps) {
  return <span aria-hidden="true" className={cn('block animate-shimmer rounded bg-surface-subtle', className ?? 'h-3.5 w-full')} />;
}
